import React, { useEffect } from "react";
import "./BusinessConsulting.css";
import appImg from "../../assets/images/business-consulting.png";

const BusinessConsulting = () => {
  useEffect(() => {
    const sections = document.querySelectorAll(".reveal-app");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-app");
          }
        });
      },
      { threshold: 0.2 }
    );

    sections.forEach((sec) => observer.observe(sec));
  }, []);

  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="app-hero-section reveal-app">
        <div className="app-hero-container">
          {/* LEFT TEXT */}
          <div className="app-hero-text reveal-app">
            <h1>Business Consulting</h1>

            <p>
              As organizations navigate an ever-changing business landscape,
              our commitment to providing comprehensive solutions is underscored
              by the introduction of strategic business consulting.
            </p>

            <p>
              We aim to empower businesses with the insights, strategies,
              and frameworks needed to achieve sustained success and growth.
            </p>

            <button className="app-hero-btn">Get Started</button>
          </div>

          {/* RIGHT IMAGE */}
          <div className="app-hero-image reveal-app">
            <img src={appImg} alt="Business Consulting" />
          </div>
        </div>
      </section>

      {/* ================= SECOND SECTION ================= */}
      <section className="app-second-section reveal-app">
  <div className="app-second-container">
    {/* LEFT FORM BOX */}
    <div className="app-form-box reveal-app">
      <h2>Get an Appointment</h2>

      <form
        action="https://api.web3forms.com/submit"
        method="POST"
      >
        {/* REQUIRED: WEB3FORMS ACCESS KEY */}
        <input
          type="hidden"
          name="access_key"
          value="157f5dfc-898c-4749-aab8-a80e612db795"
        />

        <input type="text" name="name" placeholder="Name *" required />
        <input type="email" name="email" placeholder="Email *" required />
        <textarea name="message" placeholder="Message Here" rows="5"></textarea>

        <button type="submit" className="app-send-btn">Send</button>
      </form>
    </div>

    {/* RIGHT TEXT CONTENT */}
    <div className="app-second-text reveal-app">
      <h1>Why Business Consulting?</h1>

      <p>
        In a dynamic and competitive business environment, the need for
        expert guidance and strategic planning is more crucial than ever.
        Business consulting serves as a catalyst for organizational
        excellence, helping companies optimize their operations, enhance
        efficiency, and navigate challenges effectively.
      </p>

      <p>
        NMD is eager to bring our wealth of experience and expertise to
        assist clients in achieving their business objectives.
      </p>

      <p>
        Through strategic insight, operational refinement, and
        data-driven decision-making, business consulting empowers
        organizations to unlock their full potential and stay ahead in the
        evolving market.
      </p>
    </div>
  </div>
</section>


      {/* ================= THIRD FEATURE SECTION (Same as Data Science) ================= */}
      <section className="app-features-section reveal-app">
        <h2 className="app-feature-title">More Solutions We Offer</h2>

        <div className="scroll-line"></div>

        <div className="app-features-container">
          {/* CARD 1 */}
          <div className="app-feature-card">
            <div className="card-inner">
              <div className="card-front">
                <div className="icon-box">📡</div>
                <h3>Custom App Development</h3>
                <p>
                  Tailored mobile solutions for your business, built for both
                  Android and iOS platforms.
                </p>
              </div>
              <div className="card-back">
                <h3>Custom App Development</h3>
                <p>
                  Tailored mobile solutions for your business, built for both
                  Android and iOS platforms.
                </p>
              </div>
            </div>
          </div>

          {/* CARD 2 */}
          <div className="app-feature-card">
            <div className="card-inner">
              <div className="card-front">
                <div className="icon-box">🛠️</div>
                <h3>UI/UX Design</h3>
                <p>
                  Clean, modern, and intuitive designs that boost user
                  engagement and brand identity.
                </p>
              </div>

              <div className="card-back">
                <h3>UI/UX Design</h3>
                <p>
                  Clean, modern, and intuitive designs that boost user
                  engagement and brand identity.
                </p>
              </div>
            </div>
          </div>

          {/* CARD 3 */}
          <div className="app-feature-card">
            <div className="card-inner">
              <div className="card-front">
                <div className="icon-box">⚡</div>
                <h3>Backend Development</h3>
                <p>
                  Scalable, secure, and high-performance backend architectures
                  tailored for growth.
                </p>
              </div>
              <div className="card-back">
                <h3>Backend Development</h3>
                <p>
                  Scalable, secure, and high-performance backend architectures
                  tailored for growth.
                </p>
              </div>
            </div>
          </div>

          {/* CARD 4 */}
          <div className="app-feature-card">
            <div className="card-inner">
              <div className="card-front">
                <div className="icon-box">🔐</div>
                <h3>Quality Assurance</h3>
                <p>
                  Rigorous testing procedures to ensure flawless performance and
                  user satisfaction.
                </p>
              </div>

              <div className="card-back">
                <h3>Quality Assurance</h3>
                <p>
                  Rigorous testing procedures to ensure flawless performance and
                  user satisfaction.
                </p>
              </div>
            </div>
          </div>

          {/* CARD 5 */}
          <div className="app-feature-card">
            <div className="card-inner">
              <div className="card-front">
                <div className="icon-box">☁️</div>
                <h3>Maintenance & Support</h3>
                <p>
                  Continuous improvements, updates, and security enhancements
                  for your digital solutions.
                </p>
              </div>

              <div className="card-back">
                <h3>Maintenance & Support</h3>
                <p>
                  Continuous improvements, updates, and security enhancements
                  for your digital solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BusinessConsulting;
